import type React from 'react'

import { clsJoin } from '@/utils'
import css from '../../styles.module.css'

interface ActionButtonProps {
  children: React.ReactNode
  icon?: React.ReactNode
  variant?: 'gray' | 'purple'
  onClick?: () => void
}

export const ActionButton: React.FC<ActionButtonProps> = ({
  children,
  icon,
  variant = 'gray',
  onClick,
}) => {
  const className = clsJoin(
    css.ai_chat_sidebar_action,
    variant === 'purple' && css.ai_chat_sidebar_action_purple
  )

  return (
    <div className={className} onClick={onClick}>
      {icon}
      <span>{children}</span>
    </div>
  )
}
